import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgBubbleComponent } from './pg-bubble.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PgBubbleComponent],
  exports: [PgBubbleComponent],
})
export class PgBubbleModule {}
